// services/SetupUsergroupService.ts
import axios from 'axios';
import { SetupUsergroup } from '../models/SetupUsergroup';

const API_URL = process.env.REACT_APP_SERVER_URL + "/setupusergroup";

const SetupUsergroupService = {

    getAllUserGroups: async (): Promise<SetupUsergroup[]> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getAllUserGroups`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    getAllSupplier: async (): Promise<SetupUsergroup[]> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getAllSupplier`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    getAllCustomer: async (): Promise<SetupUsergroup[]> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getAllCustomer`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    getAllLogistic: async (): Promise<SetupUsergroup[]> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getAllLogistic`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    getAllSupplierByWarehouseId: async (warehouseId: string) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getAllSupplierByWarehouseId/${warehouseId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    getAllCustomerByWarehouseId: async (warehouseId: string) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getAllCustomerByWarehouseId/${warehouseId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    getAllLogisticByWarehouseId: async (warehouseId: string) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getAllLogisticByWarehouseId/${warehouseId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    getSupplierByUserId: async (userId: string) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getSupplierByUserId/${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    getUserGroupById: async (id: number): Promise<SetupUsergroup> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getUserGroupById/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    createUserGroup: async (data: SetupUsergroup) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.post(`${API_URL}/add`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    updateUserGroup: async (id: number, data: Omit<SetupUsergroup, 'id' | 'created_time' | 'updated_time'>) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.put(`${API_URL}/edit/${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    deleteUserGroup: async (id: number): Promise<void> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        await axios.delete(`${API_URL}/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    },
};

export default SetupUsergroupService;
